// LP status, one rule for every page.
//   paused     the LP record is disabled (Enabled off on the LP page)
//   connected  enabled and its session is CONNECTED or CONNECTING
//   degraded   enabled and DEGRADED
//   stopped    enabled but its session is not running (any other state)
// Pickers and filters list an LP only while it is connected or degraded;
// reports keep every LP.

export type LpStatusBucket = 'connected' | 'stopped' | 'degraded' | 'paused';

export function lpStatusBucket(enabled: boolean | undefined, state: string | undefined): LpStatusBucket {
  if (enabled === false) return 'paused';
  switch (state) {
    case 'CONNECTED':
    case 'CONNECTING': return 'connected';
    case 'DEGRADED':   return 'degraded';
    default:           return 'stopped';
  }
}

export const isLpRunning = (b: LpStatusBucket): boolean => b === 'connected' || b === 'degraded';
